// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import VeeValidate from 'vee-validate'
import VueCalendar from 'vue-full-calendar'
import routes from './routes.js'
import * as VueGoogleMaps from 'vue2-google-maps'
import infiniteScroll from 'vue-infinite-scroll'
// import '../node_modules/ag-grid/dist/styles/ag-grid.css'
// import '../node_modules/ag-grid/dist/styles/ag-theme-balham.css'


require('sweetalert2/dist/sweetalert2.min.css')


//agGrid Enterprise
import "ag-grid-enterprise/main";
import {LicenseManager} from "ag-grid-enterprise/main";
LicenseManager.setLicenseKey("Powata_Pte_Ltd_MultiApp_1Devs13_February_2019__MTU1MDAxNjAwMDAwMA==077653976455bd55dfc6fed55c94a879");

const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true
}

// Google Maps
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCUq6Ws7jNr2LPMYlLCirNjQv0YMsHdfTY',
    v: '3'
  }
})

// We want to apply VueResource and VueRouter
// to our Vue instance
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(VeeValidate, config)
Vue.use(VueCalendar)
Vue.use(infiniteScroll)

// Global components
import AppHeader from './components/Header.vue'
import Sidebar from './components/Sidebar.vue'
import Aside from './components/Aside.vue'
import Footer from './components/Footer.vue'

const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  history: true
})

// protect routes. Allow user which are logged in
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)

  var cookies = VueCookies


  // check if the token is almost expire then refresh the token
  if (cookies.isKey('om_session')) {
    let dateNow = parseInt((new Date().getTime() / 1000))
    if (dateNow >= cookies.get('om_session_last') || !cookies.isKey('om_session_last')) {
      Vue.http.post(process.env.API_ENDPOINT + '/user/refresh?token=' + cookies.get('om_session')).then((response) => {
        cookies.remove('om_session')
        cookies.remove('om_session_info')
        cookies.remove('om_session_company')
        cookies.remove('om_session_permissions')
        cookies.remove('om_session_roles')

        cookies.set('om_session', response.body.token, '30d')
        let generalInfo = {
          'id': response.body.id,
          'first_name': response.body.first_name,
          'last_name': response.body.last_name,
          'email': response.body.email,
          'current_contract_id': response.body.current_contract_id,
          'user_level': response.body.user_level
        }
        cookies.set('om_session_info', JSON.stringify(generalInfo), '30d')
        cookies.set('om_session_company', JSON.stringify(response.body.company), '30d')
        cookies.set('om_session_permissions', (response.body.permissions), '30d')
        cookies.set('om_session_roles', JSON.stringify(response.body.roles), '30d')
        cookies.set('om_session_user_login_count', JSON.stringify(response.body.login_count), '30d')

        let date = new Date()
        let nextSessionCheck = new Date(date.setMinutes(date.getMinutes() + 50)).getTime() / 1000
        cookies.set('om_session_last', parseInt(nextSessionCheck), '30d')
      }, (response) => {
        //console.log(response)
      })
    }
  }
  cookies.set('om_session_previous_page', from.path.substring(1), '30d')
  if (to.path !== '/login' && to.path !== '/register' && to.name !== '/signup' && to.name !== '/reset' && to.path !== '/forgot' && to.path !== '/user/oauth/check') {
    // if token is not set redirect to /login
    if (cookies.get('om_session') === null) {
      next({ path: '/login' })
    } else {
      Vue.http.get(process.env.API_ENDPOINT + '/check_user_token?token=' + cookies.get('om_session')).then((response) => {
        next()
      }, (response) => {
        if (response === 'valid_token') {
          next()
        } else {
          cookies.remove('om_session')
          next({ path: '/login' })
        }
      })
    }
  } else {
    if (cookies.get('om_session') !== null) {
      next({ path: '/retailer-execution?page=1' })
    } else {
      next()
    }
  }
})

new Vue({
  components: {
    'app-header': AppHeader,
    'app-sidebar': Sidebar,
    'app-aside': Aside,
    'app-footer': Footer
  },
  router,
  methods: {
    isAdminPage: function (path, name) {
      let publicComponents = ['/login', '/register', '/signup', '/welcome', '/reset', '/forgot', '/user/oauth/check']
      return publicComponents.indexOf(path) >= 0 || publicComponents.indexOf(name) >= 0
    }
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js